import { SVGProps, Ref, forwardRef } from 'react';

export const MagnifierOutlinedHyperstarFilledSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    d="M11 1q1.065.001 2 .13v1.822a12.6 12.6 0 0 0-2-.152c-3.317 0-5.27 1.085-6.43 2.477C3.362 6.727 2.8 8.767 2.8 11s.562 4.272 1.77 5.723C5.73 18.115 7.683 19.2 11 19.2s5.27-1.085 6.43-2.477c1.208-1.45 1.77-3.49 1.77-5.723 0-.689-.053-1.36-.163-2h1.82c.096.659.143 1.33.143 2 0 2.418-.585 4.837-2.037 6.69l4.033 4.034-1.272 1.272-4.026-4.025C16.142 20.22 13.96 21 11 21 3.5 21 1 16 1 11S3.5 1 11 1"
                    fill="currentColor"
                />
                <path
                    d="M18.5 0A13.3 13.3 0 0 0 22 3.5 13.3 13.3 0 0 0 18.5 7 13.3 13.3 0 0 0 15 3.5 13.3 13.3 0 0 0 18.5 0"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
MagnifierOutlinedHyperstarFilledSize24Glyph.displayName = 'MagnifierOutlinedHyperstarFilledSize24Glyph';
